import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  createAudience,
  updateAudience,
} from '../../lib/redux/actions';
import {
  customStyles,
} from './utils';
import {
  FormContainer,
  SelectWrapper,
  ButtonGroup,
  FormTitle,
  FormWrapper,
} from './StyledComponents';
import { Label } from '../FormStyles/Input';
import { Button, StyledSelect } from '../FormStyles';
import TextInput from '../FormStyles/TextInput';
import {
  ColorsPicker
} from './ColorsPicker';
import AudiencesModal from './AudiencesModal';

const AudienceForm = ({ item: audience }) => {
  const { t } = useTranslation(['edit', 'shared']);
  const [segment, setSegment] = useState([]);
  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const [disabled, setDisabled] = useState(true);
  const title = audience ? t("edit:audienceForm:edit:title") : t("edit:audienceForm:create:title");
  const label = t("edit:audienceForm:label");
  const dispatch = useDispatch();
  const populationSegments = useSelector((state) => {
    return state.status.populationSegments.map(
      (segment) => ({ value: segment.id, label: segment.name })
    );
  })

  useEffect(() => {
    if (audience) {
      setName(audience.label || audience.name);
      setColor(audience.color);
      setSegment(audience.population);
      setDisabled(false)
    }
  }, [audience]);

  useEffect(() => {
    const isDisabled = !(name && color && segment)
    setDisabled(isDisabled);
  }, [name, color, segment]);

  const audienceParams = {
    audience: {
      name,
      color,
      population_segment_ids:
        segment.length > 0 ? segment.map(data => data.value) : [],
    },
  };

  const submitForm = () => {
    if (audience) {
      const updateParams = {
        ...audienceParams,
        id: audience.value || audience.id
      };
      dispatch(updateAudience(updateParams))
    } else {
      dispatch(createAudience(audienceParams))
    }
    AudiencesModal();
  };

  return (
    <FormWrapper>
      <FormTitle>{title}</FormTitle>
      <FormContainer>
        <TextInput
          label={label}
          placeholder={label}
          onChange={(e) => setName(e.target.value)}
          required="required"
          value={name}
        />
        <SelectWrapper>
          <Label>
          {
            t("edit:audienceForm:selectLabel")
          }
          </Label>
          <StyledSelect
            onChange={(value) => setSegment(value)}
            className="audience-filter"
            classNamePrefix="react-select"
            placeholder={t("edit:audienceForm:selectLabel")}
            value={segment}
            isClearable={true}
            options={populationSegments}
            isSearchable={true}
            isMulti={true}
            // styles={customStyles}
          />
        </SelectWrapper>
        <ColorsPicker color={color} resourceType='audience' setColor={setColor} />
        <ButtonGroup>
          <Button variant="tertiary" onClick={() => AudiencesModal()}>
            {t('shared:cancel')}
          </Button>
          <Button
            variant="containedBlue"
            ml="8px"
            type="submit"
            disabled={disabled}
            onClick={submitForm}
          >
            {t('shared:save')}
          </Button>
        </ButtonGroup>
      </FormContainer>
    </FormWrapper>
  );
};

export default AudienceForm;
